import React from 'react';
import { Form, Input, Button,Spin,Select,Switch, Divider, message } from 'antd';
import axios from 'axios'
import * as serverconfig from '../serverconn'
import { UserOutlined, LockOutlined, LoadingOutlined, MailOutlined,UploadOutlined } from '@ant-design/icons';
import moment from 'moment';

var CryptoJS = require("crypto-js");

const FormItem=Form.Item;
const antIcon = <LoadingOutlined style={{ fontSize: 60 }} spin />;

var token= ''
var username=''
const dateFormat = 'DD/MM/YYYY';
const { TextArea } = Input;


const { Option } = Select;

class WorkFlowApplicationFieldForm extends React.Component {

  state = {
    name:'' ,  
    datarequested:true,
    label:'',
    is_required:false,
    field_type:'',
    options:[],

    option_value:'',
    option_label:''

  }

  componentDidMount(){   
    this.component_reloaded()
  }


  component_reloaded=()=>{
    this.setState({datarequested:true})

    
    if(localStorage.getItem("token")){
       token= localStorage.getItem("token")
    }else{
       token= ''
    }

    if(localStorage.getItem("username")){
      username= CryptoJS.AES.decrypt(localStorage.getItem("username") , 'my-secret-key@123').toString(CryptoJS.enc.Utf8)
   
   }else{
      username=''
   }


    axios.defaults.headers={
      "Content-Type":"application/json",
      Authorization:`Token ${token}`
    }


    axios.get(serverconfig.backendserverurl+`/api/document_types/`)
    .then(res => {
        this.setState({
            document_types:res.data
        })
        this.setState({datarequested:false})
    })


  }


  //submit button pressed
  handleFormSubmit=(event) =>{
    this.setState({datarequested:true})
    let form_data = new FormData();
    form_data.append('is_required', this.state.is_required);
    form_data.append('field_type', this.state.field_type);
    form_data.append('label', this.state.label);
    form_data.append('options',JSON.stringify(this.state.options));
    form_data.append('workflow', this.props.workflow_obj.id);

    axios.post(serverconfig.backendserverurl+'/api/application_formfields/', form_data, {
      headers: {
        'content-type': 'multipart/form-data'
      }
    })
  .then(res => {
    this.setState({datarequested:false})
    this.component_reloaded()

    ///refesrh
    this.props.onRefresh()

    this.setState({is_required:false})
    this.setState({field_type:''})
    this.setState({label:''})
    this.setState({options:[]})

  }    

  )
  .catch(error => console.log(error))

  }


  //sample exists
    isoption_added = (item_name, list) => {
    return list.some((item) => item.value === item_name);
  };

  
  render(){

    if(this.state.datarequested===true){
      return(
        <div style={{display: 'flex',  justifyContent:'center', alignItems:'center' }}>
        <Spin indicator={antIcon} />
        </div>
      )

    }else{
      return (
        <div>
    <Form
        onFinish={(event) => this.handleFormSubmit(event)}
    >

      <FormItem label="Label"
        name="label"
        rules={[
          {
            required: true,
            message: 'Please input Label',
          },
        ]}
      >
        <Input name="Label" 
         placeholder="label."
          value={this.state.label} 
          onChange={(val)=>{this.setState({label:val.target.value})}} />
      </FormItem>

      <FormItem label="Field Type"
        name="field_type"
        rules={[
          {
            required: true,
            message: 'Please select',
          },
        ]}
      >
          <Select 
          placeholder="Field Type" 
          style={{  }} 
          value={this.state.field_type}
          onChange={(val)=>{
            this.setState({field_type:val})
          }} 
          showSearch
          optionFilterProp="children"
          onFocus={this.onFocus}
          onBlur={this.onBlur}
          onSearch={this.onSearch}   
          >
                <Option value={'text'}>{'Text'}</Option>
                <Option value={'textarea'}>{'Textarea'}</Option>
                <Option value={'number'}>{'Number'}</Option>
                <Option value={'date'}>{'Date'}</Option>
                <Option value={'file'}>{'File'}</Option>
                <Option value={'select'}>{'Dropdown'}</Option>
                <Option value={'checkbox'}>{'Checkbox'}</Option>

          </Select>
      </FormItem>



        <Form.Item label="Required?" >
          <Switch
              checked={this.state.is_required}
              onChange={val=>{this.setState({is_required:val})}}
              checkedChildren="Yes"
              unCheckedChildren="No"
              />
        </Form.Item>

        {this.state.field_type==="select"?
        <div style={{display:'flex',flexDirection:'row',flexWrap:'wrap',justifyContent:'space-evenly'}}>
           <Divider></Divider>

          <FormItem label="Label">
            <Input name="Label" 
            placeholder="label."
              value={this.state.option_label} 
              onChange={(val)=>{this.setState({option_label:val.target.value})}} />
          </FormItem>

          <FormItem label="Value">
            <Input name="Value" 
            placeholder="Value."
              value={this.state.option_value} 
              onChange={(val)=>{this.setState({option_value:val.target.value})}} />
          </FormItem>

          <FormItem>
            <Button  type="primary" htmlType="button" 
             onClick={()=>{
              if (this.isoption_added(this.state.option_value,this.state.options)){
                message.error("Already added")
              }else{
                var intobj={
                  'key':this.state.options.length+1,
                  'value':this.state.option_value,
                  'label':this.state.option_label,
                }

                var new_array = [
                  ...this.state.options,
                  intobj,
                ];
                this.setState({ options: new_array });


                //reset options field
                this.setState({option_value:''})
                this.setState({option_label:''})

              }

            }}>Add Option</Button>
          </FormItem>

          <Divider></Divider>
          {this.state.options.length>0?
            <ul>
            {this.state.options.map((item) => (
              <li key={item.key}>
                <strong>Label:</strong> {item.label}, <strong>Value:</strong> {item.value}
              </li>
            ))}
          </ul>
          :
          null
          }
          <Divider></Divider>

        </div>
        :null}

      <FormItem>
        <Button  type="primary" htmlType="submit">Create </Button>
      </FormItem>
       </Form>
        </div>
      );
    }

  }

}


export default WorkFlowApplicationFieldForm;



